module.exports = __webpack_public_path__ + "assets/img/ios_store.1f2918d6.png";